import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  catalogObject: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/catalog/vuex/index.js